/**
 * Redirect /track/* pages to accounts.thebookcove.com
 */
(function () {
  // Check if current path starts with /track/
  if (window.location.pathname.startsWith("/track/")) {
    // Redirect to accounts subdomain with same path and search params
    window.location.href = `https://account.thebookcove.com${window.location.pathname}${window.location.search}`;
  }
})();
